<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <p class="title text-xs-center">Add Network URL(Offer URL)</p>
        <v-form ref="form" v-model="valid" lazy-validation>

          <v-autocomplete
            :items="networkNames"
            :rules="[v => !!v || 'Please select network name.']"
            v-model="network"
            label="Select Network"
            persistent-hint
            required
          ></v-autocomplete>

          <v-autocomplete
            :items="countryNames"
            v-model="country"
            :rules="[v => !!v || 'Please select country name.']"
            label="Select Country"
            persistent-hint
            required
          ></v-autocomplete>

          <v-autocomplete
            :items="operatorNames"
            :rules="[v => !!v || 'Please select operator name.']"
            v-model="operator"
            label="Select Operator(select country first)"
            persistent-hint
            required
          ></v-autocomplete>

          <v-autocomplete
            v-model="advertiserUrl"
            :items="advertiserUrlDetails"
            :rules="[v => !!v || 'Please select advertiser url.']"
            label="Select Advertiser Url"
            persistent-hint
            required
          ></v-autocomplete>

          <v-select
            :items="OSTypes"
            :rules="[v => !!v || 'Please select Operating System.']"
            v-model="OSType"
            label="Select OS Type"
          ></v-select>

          <v-select
            :items="trafficTypes"
            :rules="[v => !!v || 'Please select Traffic.']"
            v-model="trafficType"
            label="Select Traffic Type"
          ></v-select>

          <v-select
            :items="modelTypes"
            :rules="[v => !!v || 'Please select model type.']"
            v-model="modelType"
            label="Select Models Type"
          ></v-select>

          <v-text-field
            type="number"
            v-model="payout"
            label="Payout($)"
          ></v-text-field>
          <div class="text-xs-center">
            <v-btn @click="clear">clear</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="submitNetworkUrl">
              Add Network Url
            </v-btn>
          </div>
        </v-form>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title class="title">
              If you want you can Change Postback details?
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="postbackUrl"
                :rules="[v => !!v || 'Please provide postback url.']"
                label="Postback Url"
                required
              ></v-text-field>
              <v-text-field
                type="number"
                v-model="filter"
                label="Filter"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <div class="text-xs-center">
                <v-btn color="primary" flat @click.stop="dialog = false">Cancel</v-btn>
                <v-btn color="primary" flat @click.stop="dialog = false; submit();">Submit</v-btn>
              </div>
            </v-card-actions>
        </v-card>
      </v-dialog>

      </v-flex>

    </v-layout>
</template>

<script>
import axios from "axios";

import { SERVER_URL } from "./../../constant.js";

export default {
  data: () => ({
    valid: true,
    loading: false,
    network: "",
    networks: [],
    networkNames: [],
    searchNetwork: null,

    country: "",
    countries: [],
    countryNames: [],
    searchCountry: null,

    operator: "",
    operators: [],
    operatorNames: [],
    searchOperator: null,

    advertiserUrl: "",
    advertiserUrls: [],
    advertiserUrlDetails: [],
    searchAdvertiserUrl: "",

    OSType: "",
    OSTypes: ["Android", "iOS"],
    trafficType: "",
    trafficTypes: ["A", "C", "I", "IG"],
    modelType: "",
    modelTypes: ["CPA", "CPC", "CPM", "CPI"],
    payout: 0,
    status: true,

    dialog: false,
    postbackUrl: '',
    filter: 0
  }),
  created() {
    document.title = 'Add Network Url';
    var vm = this;
    Promise.all([
      axios.get(`${SERVER_URL}/network/all`),
      axios.get(`${SERVER_URL}/country/all`),
      //axios.get(`${SERVER_URL}/advertiser/allUrl`)
    ]).then(results => {
      results[0].data.forEach(val => {
        vm.networks.push(val);
        vm.networkNames.push(val.name);
      });
      results[1].data.forEach(val => {
        vm.countries.push(val);
        vm.countryNames.push(val.name);
      });
    });
  },

  watch: {
    country(val) {
      var vm = this;
      vm.operators = [] 
      vm.operatorNames = [];
      axios.get(`${SERVER_URL}/operator/bycountry/${val}`).then(res => {
        res.data.forEach(val => {
          vm.operators.push(val);
          vm.operatorNames.push(val.name);
        });
      });
    },

    operator(selectedOperatorName) {
      var vm = this;
      if(!selectedOperatorName) {
        vm.advertiserUrls = [] 
        vm.advertiserUrlDetails = [];
        return;
      }
      var val = this.operators.find(op => op.name === selectedOperatorName);
      vm.advertiserUrls = [] 
      vm.advertiserUrlDetails = [];
      axios.get(`${SERVER_URL}/advertiser/urls/byOperatorId/${val.operatorId}`).then(res => {
        res.data.sort(vm.advUrlComparator).forEach(val => {
          vm.advertiserUrls.push(val);
          vm.advertiserUrlDetails.push(`${val.advertiserUrlId}-${val.advertiserCampaignName}`);
        });
      });
    }
  },
  methods: {

    advUrlComparator(a,b) {
      if (a.advertiserName < b.advertiserName)
        return -1;
      if (a.advertiserName > b.advertiserName)
        return 1;
      return 0;
    },

    submitNetworkUrl() {
      if (this.$refs.form.validate()) {
        let selectedNetwork = this.networks.find( netk => netk.name === this.network );
        this.postbackUrl = selectedNetwork.postbackUrl;
        this.filter = selectedNetwork.filter;
        this.dialog = true;
      }
    },

    submit() {

      if (this.$refs.form.validate()) {

      let selectedNetwork = this.networks.find( netk => netk.name === this.network );

      let selectedCountry = this.countries.find( cntry => cntry.name === this.country);

      let selectedOperator = this.operators.find( optor => optor.name === this.operator );

      let selectedAdvertiserUrl;

      if (this.advertiserUrl) {
        let advertiserUrlId = Number(
          this.advertiserUrl.substring(0, this.advertiserUrl.indexOf("-"))
        );
        selectedAdvertiserUrl = this.advertiserUrls.find( advUrl => advUrl.advertiserUrlId === advertiserUrlId );
      }

      var payload = {

        networkId: selectedNetwork.networkId,
        networkName: selectedNetwork.name,
        clickIdParameter: selectedNetwork.clickIdParameter,
        postbackUrl: this.postbackUrl,
        filter: this.filter,

        countryId: selectedCountry.countryId,
        countryName: selectedCountry.name,

        operatorId: selectedOperator.operatorId,
        operatorName: selectedOperator.name,

        OSType: this.OSType,
        trafficType: this.trafficType,
        modelType: this.modelType,

        advertiserId: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserId : null,
        advertiserName: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserName : null,

        advertiserUrlId: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserUrlId : null,
        advertiserUrl: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserUrl : "",
        advertiserCampaignName: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserCampaignName : "",

        payout: this.payout

      };
      axios.post(`${SERVER_URL}/network/addUrl`, payload).then(res => {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Added Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        this.$refs.form.reset();
      });
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/network/AddNetworkUrl.vue